// extracted by mini-css-extract-plugin
module.exports = {"button":"MobileTopMenuButton_button__ZmMjg","icon":"MobileTopMenuButton_icon__3__Fx"};